import { zodResolver } from '@hookform/resolvers/zod';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Button } from '../../../shared/ui/button';
import { Field } from '../../../shared/ui/field';
import { Input } from '../../../shared/ui/input';
import { type Credentials, type CredentialsSubmit, credentialsSchema } from './model';

export function SignInForm({ onSubmit }: { onSubmit: CredentialsSubmit }) {
  const { t } = useTranslation('auth');
  const [serverError, setServerError] = useState<string | null>(null);
  const { register, handleSubmit, formState } = useForm<Credentials>({
    resolver: zodResolver(credentialsSchema),
  });
  return (
    <form
      className="space-y-4"
      onSubmit={handleSubmit(async (values) => {
        setServerError((await onSubmit(values)).error);
      })}
    >
      <Field label={t('fields.email')} error={formState.errors.email?.message}>
        <Input id="email" type="email" {...register('email')} />
      </Field>
      <Field label={t('fields.password')} error={formState.errors.password?.message}>
        <Input id="password" type="password" {...register('password')} />
      </Field>
      {serverError ? (
        <p role="alert" className="text-sm text-destructive">
          {serverError}
        </p>
      ) : null}
      <Button type="submit" className="w-full" disabled={formState.isSubmitting}>
        {t('signIn.submit')}
      </Button>
    </form>
  );
}
